// extracted by mini-css-extract-plugin
module.exports = {"not-found":"styles_not-found__3rORy","not-found__title":"styles_not-found__title__4Oy5v","not-found__text":"styles_not-found__text__2bMTU"};